import { useContext } from "react";
import { ApiContext } from "../components/ApiProvider";

export function useApi() {
  return useContext(ApiContext);
}
